"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transText = transText;

var _utils = require("../utils");

var _formula = require("./formula");

function readValue(text) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var str = text.substring(2, text.length - 2).trim();
  var index = str.indexOf('('); // 不是函数

  if (index === -1) {
    if (str.charAt(0) === '\'' && str.charAt(str.length - 1) === '\'') {
      return str.substring(1, str.length - 1);
    }

    if (/^[\d]+$/.test(str)) {
      return Number(str);
    }

    return (0, _utils.getDataByName)(data, str);
  } // 是函数


  var funcName = str.substring(0, index);
  var lastIndex = str.lastIndexOf(')');
  var content = str.substring(index + 1, lastIndex); // eval 函数特殊处理

  if (funcName === '$EVAL') {
    return eval(content);
  }

  var params = [];
  var count = 0;
  var startIndex = 0;

  for (var i = 0; i < content.length; ++i) {
    var char = content.charAt(i);

    if (char === '(') {
      count += 1;
    } else if (char === ')') {
      count -= 1;
    } else if (char === ',') {
      if (count < 0) {
        console.error('Formula Error!');
        return;
      }

      if (count === 0) {
        params.push(readValue("{{".concat(content.substring(startIndex, i), "}}"), data));
        startIndex = i + 1;
      }
    }
  }

  if (count > 0) {
    console.error('Formula Error!');
    return;
  }

  if (startIndex !== content.length) {
    params.push(readValue("{{".concat(content.substring(startIndex), "}}"), data));
  }

  return _formula.formula.apply(void 0, [funcName].concat(params));
}

function transText(text) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var matchKeys = text.match(/{{.*?}}/g);

  if (!matchKeys) {
    return text;
  } // 是一个对象


  if (matchKeys.length === 1 && matchKeys[0] === text) {
    return readValue(text, data);
  } // 是一个字符串


  var res = text;
  matchKeys.forEach(function (key) {
    res = res.replace(key, readValue(key, data));
  });
  return res;
}